export default "__VITE_PUBLIC_ASSET__a895023c__"